module.exports = __webpack_public_path__ + "img/logo.799e2428.svg";